/**
 * Guía: Ingresos por Compañía.
 *
 * Contenido derivado del capítulo **20** del manual: §0 (la pregunta que
 * responde, y el aviso de que ninguna de sus cifras significaba lo que
 * decía) y del flujo F34.
 *
 * Es de sólo lectura, así que la guía se centra en qué mide cada columna —
 * que es donde estaba el problema.
 */

import type { TourFlow } from '../types';

const INGRESOS_PATH = '/finance-companies';

export const c20IngresosPorCompania: TourFlow = {
  id: 'admin.finance-companies',
  chapter: '20',
  title: 'Ingresos por Compañía',
  summary:
    'Cuánto factura cada comercio y cuánto deja: qué mide cada columna y con qué no se compara.',
  href: INGRESOS_PATH,
  requiresCountry: true,
  estimatedMin: 3,
  steps: [
    {
      id: 'intro',
      title: 'La pregunta del cierre de mes',
      body:
        'Cuánto factura cada comercio del país y cuánto deja a la plataforma. Una fila por ' +
        'compañía, con sus pedidos, sus ingresos, las tarifas que generó, su comisión y su ' +
        'suscripción.',
      route: INGRESOS_PATH,
    },
    {
      id: 'two-columns-two-things',
      title: 'Lo que factura el comercio no es lo que deja',
      body:
        'Una columna es el volumen que pasó por ese comercio; otra, lo que de eso se queda ' +
        'la plataforma. Son la misma distinción del panel financiero, aplicada comercio a ' +
        'comercio.',
      target: 'admin.financeCompanies.kpis',
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'not-a-payout',
      title: 'Esto no es lo que se le paga',
      body:
        'Lo que un comercio cobra sale de sus liquidaciones, que cuentan otra cosa: sólo ' +
        'pedidos completados, netos de reembolsos y sin efectivo. Comparar esta pantalla ' +
        'con una liquidación da distinto y las dos son correctas.',
    },
    {
      id: 'read-only',
      title: 'No se escribe nada aquí',
      body:
        'Ni se ajusta una comisión ni se corrige un importe. Si una cifra no cuadra, lo que ' +
        'se revisa son los pedidos y las liquidaciones que la componen.',
    },
  ],
};
